import React from 'react';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';

/**
 * Diálogo de confirmación reutilizable.
 *
 * @param {string}   title         - Encabezado del diálogo
 * @param {string}   message       - Mensaje/pregunta que se muestra
 * @param {string}   [icon]        - Ícono PrimeIcons (ej: 'pi pi-trash')
 * @param {string}   [acceptLabel] - Texto del botón de confirmación (default: 'Confirmar')
 * @param {string}   [rejectLabel] - Texto del botón de cancelar    (default: 'Cancelar')
 * @param {string}   [className]   - Clase CSS extra para el diálogo
 * @param {function} onAccept      - Callback cuando el usuario confirma
 * @param {function} [onReject]    - Callback cuando el usuario cancela
 * @param {object}   trigger       - Config del botón disparador: { label, icon, className }
 */

export const ConfirmActionDialog = ({
  title,
  message,
  icon = 'pi pi-exclamation-triangle',
  acceptLabel = 'Confirmar',
  rejectLabel = 'Cancelar',
  className = '',
  onAccept,
  onReject,
  trigger = {},
}) => {

  const { label, className: triggerClass, ...triggerRest } = trigger;

  const handleReject = () => {
    if (onReject) onReject();
  };

  const openDialog = () => {
    confirmDialog({
      message,
      header: title,
      icon,
      defaultFocus: 'reject',
      acceptLabel,
      rejectLabel,
      acceptClassName: 'p-confirm-dialog-accept',
      rejectClassName: 'p-confirm-dialog-reject',
      className,
      accept: onAccept,
      reject: handleReject,
    });
  };

  return (
    <>
      <Button
        type="button"
        icon={icon}
        label={label}
        className={triggerClass}
        onClick={openDialog}
        {...triggerRest}
      />
    </>
  );
};

export default ConfirmActionDialog;